import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './CookieBanner.css';
const STORAGE_KEY = 'tween.cookie-consent';
function readConsent() {
    try {
        const value = localStorage.getItem(STORAGE_KEY);
        if (value === 'accepted' || value === 'essential')
            return value;
    }
    catch {
        // ignore storage errors
    }
    return null;
}
function writeConsent(value) {
    try {
        localStorage.setItem(STORAGE_KEY, value);
    }
    catch {
        // ignore storage errors
    }
}
export function CookieBanner() {
    const [visible, setVisible] = useState(false);
    useEffect(() => {
        setVisible(readConsent() === null);
    }, []);
    const choose = (value) => {
        writeConsent(value);
        setVisible(false);
    };
    if (!visible)
        return null;
    return (_jsx("div", { className: "cookie-banner", role: "dialog", "aria-labelledby": "cookie-banner-title", "aria-live": "polite", children: _jsxs("div", { className: "cookie-banner-inner", children: [_jsxs("div", { className: "cookie-banner-copy", children: [_jsx("p", { id: "cookie-banner-title", className: "cookie-banner-title", children: "Cookies" }), _jsxs("p", { className: "cookie-banner-text", children: ["We use essential cookies to keep you signed in, plus optional cookies to understand usage and improve tween.studio. See our", ' ', _jsx(Link, { to: "/privacy", className: "cookie-banner-link", children: "Privacy Policy" }), ' ', "for details."] })] }), _jsxs("div", { className: "cookie-banner-actions", children: [_jsx("button", { type: "button", className: "cookie-banner-btn cookie-banner-btn-secondary", onClick: () => choose('essential'), children: "Essential only" }), _jsx("button", { type: "button", className: "cookie-banner-btn cookie-banner-btn-primary", onClick: () => choose('accepted'), children: "Accept all" })] })] }) }));
}
